import React from 'react';
import TopBar from '../components/Layout/TopBar';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import MobileBottomNav from '../components/Layout/MobileBottomNav';
import HeroSlider from '../components/Home/HeroSlider';
import CategoryStrip from '../components/Home/CategoryStrip';
import DealSection from '../components/Home/DealSection';
import BrandStrip from '../components/Home/BrandStrip';
import Filters from '../components/Shop/Filters';
import ProductGrid from '../components/Shop/ProductGrid';
import CartDrawer from '../components/Cart/CartDrawer';
import QuickViewModal from '../components/Modals/QuickViewModal';
import LoginModal from '../components/Auth/LoginModal';
import Toast from '../components/UI/Toast';
import { useStore } from '../context/StoreContext';

export default function HomePage() {
  const { getFilteredProducts, sort, setSort, filters } = useStore();
  const filtered = getFilteredProducts();

  return (
    <>
      <TopBar />
      <Header />
      
      <main>
        <HeroSlider />
        <CategoryStrip />
        <DealSection />
        <LoginModal />
        
        <section id="shop" className="max-w-[1400px] mx-auto px-4 lg:px-6 mt-14">
          <div className="flex flex-col lg:flex-row gap-8">
            <Filters />
            
            <main className="flex-1 min-w-0">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
                <div>
                  <h2 className="font-display text-[30px] leading-tight">All Products</h2>
                  <p className="text-sm text-slate-500 mt-0.5">Showing {filtered.length} products</p>
                </div>
                <div className="flex items-center gap-3">
                  <select 
                    value={sort}
                    onChange={(e) => setSort(e.target.value)}
                    className="h-11 rounded-2xl border border-slate-300 bg-white px-3 text-sm font-medium outline-none focus:ring-4 focus:ring-indigo-500/10"
                  >
                    <option value="popular">Sort: Popular</option>
                    <option value="new">New Arrivals</option>
                    <option value="price-low">Price: Low to High</option>
                    <option value="price-high">Price: High to Low</option>
                    <option value="discount">Best Discount</option>
                  </select>
                </div>
              </div>
              <ProductGrid />
            </main>
          </div>
        </section>
        
        <BrandStrip />
      </main>
      
      <Footer />
      <MobileBottomNav />
      <CartDrawer />
      <QuickViewModal />
      <Toast />
    </>
  );
}